import { hiddenField, optionField, stringField } from 'common/utils/form/fieldTypes';

const config = {
  id: hiddenField(),
  organization: stringField({ required: true }),
  store_group: optionField()
};

export default config;
